import { render, staticRenderFns } from "./ChangeOrganization.vue?vue&type=template&id=3dcf45b9&scoped=true&"
import script from "./ChangeOrganization.vue?vue&type=script&lang=js&"
export * from "./ChangeOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrganization.vue?vue&type=style&index=0&id=3dcf45b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf45b9",
  null
  
)

export default component.exports